/* eslint-disable no-undef */
/* eslint-disable max-len */
/**
 * BSD Zero Clause License
 *
 * Copyright (c) 2021 Brion Mario
 *
 * Permission to use, copy, modify, and/or distribute this software for any
 * purpose with or without fee is hereby granted.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
 * REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
 * AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
 * INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
 * LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
 * OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
 * PERFORMANCE OF THIS SOFTWARE.
 */

/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

import $ from "jquery";
import "./src/assets/styles/index.scss";

// function loadScript(src) {
//     return new Promise(function (resolve, reject) {
//         var script = document.createElement("script");
//         script.onload = function () {
//             resolve();
//         };
//         script.onerror = function () {
//             reject();
//         };
//         script.src = src;
//         script.defer = true;
//         script.async = true;
//         document.body.appendChild(script);
//     });
// }

// document.addEventListener("DOMContentLoaded", function(event) {
// //     setTimeout(function() {
// //         loadScript("https://apis.google.com/js/platform.js").then(()=>{
// //             console.log("Google API Js loaded");
// //         });
// //     }, 100);
// //     setTimeout(function() {
// //         loadScript("//platform-api.sharethis.com/js/sharethis.js#property=5c27c3f4d02b6e0010eca5a8&product=inline-share-buttons").then(()=>{
// //             console.log("Sharebuttons Js loaded");
// //         });
// //     }, 100);
// //     setTimeout(function() {
// //         loadScript("https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v13.0&appId=322426884980362&autoLogAppEvents=1").then(()=>{
// //             console.log("Facebook SDK Js loaded");
// //         });
// //     }, 100);
//     console.log("DOMContentLoaded event");
//     setTimeout(function() {
//         console.log("DOMContentLoaded event - aos");
//         loadScript("").then(()=>{
//             console.log("");
//             // eslint-disable-next-line no-undef
//             AOS.init();
//         });
//     }, 100);

// });

// eslint-disable-next-line no-undef
// $(function() {
// $.getScript( "https://unpkg.com/aos@next/dist/aos.js" )
//     .done(function( script, textStatus ) {
//         console.log("aos.js");
//         console.log( textStatus );
//     });
// });

$(() => {
    // console.log("JQuery available, document loaded");
    // console.log("setting google map")
    // $.getScript( "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v13.0&appId=322426884980362&autoLogAppEvents=1" )
    //     .done(function( script, textStatus ) {
    //         console.log("loading facebook sdk.js");
    //         console.log( textStatus );
    //     });
    // $.getScript( "//platform-api.sharethis.com/js/sharethis.js#property=5c27c3f4d02b6e0010eca5a8&product=inline-share-buttons" )
    //     .done(function( script, textStatus ) {
    //         console.log("platform-api.sharethis.com");
    //         console.log( textStatus );
    //     });
});

function _initPage() {
   
    _initZoho();
}
const _initZoho = async () => {
    window.$zoho = window.$zoho || {};
    $zoho.salesiq = $zoho.salesiq || {
        widgetcode:
      "cd43817c05a86034b8ad824a530e4e3d33921339f66fd9f3d21aeb1ca335dd2f98226a7e56b457bcaa14e7654c99b1bf",
        values: {},
        ready: function () {}
    };
    const d = document;
    const s = d.createElement("script");
    s.type = "text/javascript";
    s.id = "zsiqscript";
    s.defer = true;
    s.src = "https://salesiq.zoho.com/widget";
    const t = d.getElementsByTagName("script")[0];
    t.parentNode.insertBefore(s, t);
};
const _initZoom = async () => {
    // event images click events
    $(".imgzoom")
        .click(function ($event) {
            zoomImage($event.originalEvent);
        })
        .css({ cursor: "pointer" });

    $(document).keyup(function (e) {
        if (e.keyCode === 27) {
            document.getElementById("imageZoomModal").style.display = "none";
        }
    });
};

function zoomImage(event) {
    // Get the modal
    var modal = document.getElementById("imageZoomModal");
    var modalImg = document.getElementById("imgZoomModelContent");
    var captionText = document.getElementById("captiontxt");
    var img = event.srcElement; //document.getElementById("myImg");

    // Get the image and insert it inside the modal - use its "alt" text as a caption
    modal.style.display = "block";
    modalImg.src =
    typeof img.dataset.src === "undefined" ? img.src : img.dataset.src;
    captionText.innerHTML = img.alt;

    // Get the <span> element that closes the modal
    var span = document.getElementsByClassName("close")[0];

    // When the user clicks on <span> (x), close the modal
    span.onclick = function () {
        modal.style.display = "none";
    };
}



// final //

$(document).ready(function () {
    setTimeout(() => {
        _initZoom();
    }, 1000);
    _initPage();
   
});
